import React from "react";
import clsx from "clsx";

import styles from "./layout.module.scss";

type ViewContainerProps = {
	className?: string;
	style?: React.CSSProperties;
	children: any;
};

export const ViewContainer = ({
	children,
	className,
	style,
}: ViewContainerProps) => {
	return (
		<div
			className={clsx(styles.viewContainer, className)}
			style={{ ...style }}
		>
			{children}
		</div>
	);
};
